module.exports = __webpack_public_path__ + "img/lk-mode-back.7c765c3a.svg";